// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"327":"5e843e6648162e5b","888":"589b62a9c48dbdc7"}[chunkId] + ".css";
};